import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { DartboardTableService } from '../table-data.service';

@Component({
  selector: 'app-table-header',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss']
})
export class TableHeaderComponent implements OnInit {
  @Input() jobs : any[];
  showKpis : boolean = false;
  constructor(
    public dartboardTableService: DartboardTableService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['jobs'].currentValue != changes['jobs'].previousValue) {
      if (changes['jobs'].currentValue) this.setUp()
    }
  }

  toggleKpis() {
    this.showKpis = !this.showKpis;
  }

  async setUp() {
    this.resetTotals()
    await this.getTotals()
  }

  async getTotals() {
    this.jobs?.forEach( job => {
      if (job.status == 'sold') {
        this.dartboardTableService.soldCount$.next(this.dartboardTableService.soldCount$.value + 1)
        this.dartboardTableService.soldJobs$.next([...this.dartboardTableService.soldJobs$.value, job])
      } else if (job.status == 'lost') {
        this.dartboardTableService.lostCount$.next(this.dartboardTableService.lostCount$.value + 1)
      } else if (job.status == 'pending') {
        this.dartboardTableService.pendingCount$.next(this.dartboardTableService.pendingCount$.value + 1)
      }
    })
    return true
  }

  resetTotals() {
    this.dartboardTableService.soldJobs$.next([])
    this.dartboardTableService.soldCount$.next(0)
    this.dartboardTableService.lostCount$.next(0)
    this.dartboardTableService.pendingCount$.next(0)
  }

}
